module.exports = __webpack_public_path__ + "img/map-marker-icon-orange.95eeb680.png";